import { endOfDay } from "date-fns";
import * as Yup from 'yup';
import { dateIsBefore } from '../../../../util/validacionesYup';

export const trabajadoresValidation = (trabajadores) => Yup.object().shape({
  idTrabajador: Yup.string().nullable().required("Campo Obligatorio").test({
    name: "sinTrabajadoresRepetidos",
    message: "El trabajador ya está registrado en la grilla.",
    test: function (value) {
      return !trabajadores.some((t, index) => {
        return t?.idTrabajador.toString() === value && index !== this.parent?.index
      });
    }
  }),
  idSector: Yup.string().nullable()
    .when("exposicion", {
      is: false,
      then: Yup.string()
        .nullable()
        .required("Campo Obligatorio"),

    }),
  idPuesto: Yup.string().nullable()
    .when("exposicion", {
      is: false,
      then: Yup.string()
        .nullable()
        .required("Campo Obligatorio"),

    }),
  fechaIngreso: Yup.date().nullable()
    .required("Campo Obligatorio")
    .typeError('Fecha inválida')
    .test({
      name: "fechaLimiteVerificacion",
      message:
        "La fecha de ingreso no puede ser una fecha futura.",
      test: (value, testContext) => {
        if (!value) {
          return true;
        }

        return dateIsBefore(value, endOfDay(new Date()));
      },
    }),
  inicioContacto: Yup.date().nullable()
    .when("exposicion", {
      is: false,
      then: Yup.date()
        .nullable()
        .required("Campo Obligatorio")
        .typeError('Fecha inválida')
    })

    .typeError('Fecha inválida')
    .test({
      name: "fechaLimiteVerificacion",
      message:
        "La fecha de inicio de contacto debe ser igual o posterior a la fecha de ingreso a la empresa.",
      test: (value, testContext) => {
        if (!value || !testContext.parent.fechaIngreso) {
          return true;
        }

        return dateIsBefore(testContext.parent.fechaIngreso, value);
      },
    })
  ,
  finContacto: Yup.date()
    .nullable()
    .typeError('Fecha inválida')
    .test({
      name: "fechaLimiteVerificacion",
      message:
        "La fecha de fin de contacto no puede ser anterior a la fecha de inicio de contacto.",
      test: (value, testContext) => {
        if (!value || !testContext.parent.inicioContacto) {
          return true;
        }

        return dateIsBefore(testContext.parent.inicioContacto, value);
      },
    }),
})